import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import './videoCSS.css';
import { useTrack } from '../../twilio/hooks';

// HTML <audio> elements should not be moved around when UI changes
const ParticipantAudio = ({ member }) => {
  const audioRef = useRef();
  const volume = useSelector((state) => state.settings.volume);

  const name = member && member.name;
  const trackSelector = useCallback(
    (track, participant) => {
      return participant.identity === name && track.kind === 'audio';
    },
    [name]
  );
  const audioTrack = useTrack(trackSelector);

  useEffect(() => {
    if (!audioTrack) {
      return;
    }
    const audioElement = audioTrack.attach(audioRef.current);
    if (!audioRef.current) {
      document.body.appendChild(audioElement);
    }
    audioElement.volume = volume;
    return () => {
      audioTrack.detach(audioElement);
    };
  }, [audioTrack]);

  return (
    <Box display="none">
      {/*eslint-disable-next-line*/}
      <audio ref={audioRef} autoPlay={true} muted={false} />
    </Box>
  );
};

ParticipantAudio.propTypes = {
  member: PropTypes.object,
};

export default ParticipantAudio;
